import React, { FC } from 'react';
import { CalendarPricingType } from '@/components/houses/_hooks/useProduct';
import BasicInfo from '@/components/houses/_reusable/houseInfo/basicInfo/BasicInfo';
import HouseFeatures from '@/components/houses/_reusable/houseInfo/houseFeatures/HouseFeatures';
import HouseServices from '@/components/houses/_reusable/houseInfo/houseServices/HouseServices';
import Rules from '@/components/houses/_reusable/houseInfo/rules/Rules';
import Reviews from '@/components/houses/_reusable/houseInfo/reviews/Reviews';
import CalendarPricing from '@/components/houses/_reusable/houseInfo/calendarPricing/CalendarPricing';
import HostProfileContainer from '@/components/houses/_reusable/houseInfo/hostProfileContainer/HostProfileContainer';
import HouseAbout from '@/components/houses/_reusable/houseInfo/houseAbout/HouseAbout';
import HouseVideo from './houseVideo/HouseVideo';
import Box from '@/components/UI/box/Box';
import MidTermTehranInfo from './basicInfo/midtermTehranInfo/MidtermTehranInfo';
import { useMidTermQuery } from '@/components/houses/_hooks/useMidterm';
import { ProductItemTypes } from '../../_types/productItem.types';
import HostProfile from './basicInfo/hostProfile/HostProfile';
import HouseMap from './houseMap/HouseMap';
import HouseTags from './houseTags/HouseTags';
import SimilarHousesContainer from './similarHousesContainer/SimilarHousesContainer';
import useDevice from '@/hooks/useDevice';
import UnitCountInfo from './unitCountInfo/UnitCountInfo';
import styles from './HouseInfo.module.scss';
import HouseBundleBanner from './houseBundleBanner/HouseBundleBanner';
import HouseBreadcrumb from './houseBreadcrumb/HouseBreadcrumb';
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider';
import TitleReviewsAndLocation from './basicInfo/titleReviewsAndLocation/TitleReviewsAndLocation';
type HouseInfoProps = {
  productState: ProductItemTypes;
  calendarPricing: CalendarPricingType;
  host: string;
};
const HouseInfo: FC<HouseInfoProps> = ({
  productState,
  calendarPricing,
  host
}) => {
  const {
    isMidTerm
  } = useMidTermQuery(productState);
  const isUnitCount = productState?.is_units_count;
  const {
    isMobile
  } = useDevice();
  const isWhiteLabel = useIsWhiteLabel();
  return <Box className={styles['container']} data-sentry-element="Box" data-sentry-component="HouseInfo" data-sentry-source-file="HouseInfo.tsx">
      {!isMobile && <TitleReviewsAndLocation productState={productState} />}
      <BasicInfo props={productState} data-sentry-element="BasicInfo" data-sentry-source-file="HouseInfo.tsx" />
      {isUnitCount && <UnitCountInfo />}
      <HouseFeatures props={productState} data-sentry-element="HouseFeatures" data-sentry-source-file="HouseInfo.tsx" />
      <HouseServices props={productState} data-sentry-element="HouseServices" data-sentry-source-file="HouseInfo.tsx" />
      {isMidTerm && <HouseVideo videoId={productState?.video_id} />}
      <HouseAbout about={productState?.about} data-sentry-element="HouseAbout" data-sentry-source-file="HouseInfo.tsx" />
      {productState?.discount_motivation && !isMidTerm && !isWhiteLabel && <HouseBundleBanner data={productState?.discount_motivation} />}
      {isMidTerm && <HostProfile props={productState} />}
      <Rules props={productState} data-sentry-element="Rules" data-sentry-source-file="HouseInfo.tsx" />
      {isMidTerm && <HouseMap distances={productState?.distances?.records} location={productState?.location} />}
      {isMidTerm && !isWhiteLabel && <MidTermTehranInfo props={productState} />}
      {!isMidTerm && <>
          <Reviews props={productState} />
          <HouseVideo videoId={productState?.video_id} />
          <HouseMap distances={productState?.distances?.records} location={productState?.location} />
        </>}
      {!(isMidTerm && isMobile) && <CalendarPricing details={productState} hookData={calendarPricing} />}
      {isMidTerm && <Reviews props={productState} />}

      {!isMidTerm && <HostProfileContainer hostId={productState?.host?.id} />}
    </Box>;
};
export default HouseInfo;